<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Cambio"
        :has-back-button="true"
        :has-close-button="true"
        :is-overlay="true"
      />
      <o-map :markers="markers" />
      <o-section-header title="Reservatie wijzigen">
        <template #right>
          <o-icon
            icon="support2"
            @click.native="showOverlay('supportOverlay')"
          />
          <o-icon icon="info" @click.native="showOverlay('infoOverlay')" />
        </template>
      </o-section-header>
      <o-cambio-reservation-form
        :edit="true"
        :active="true"
        @editTime="showOverlay('tijd')"
        @standInfo="showStandInfo"
        @klasseInfo="showKlasseInfo"
      />
    </o-view>
    <o-overlay title="Tijd wijzigen" ref="tijd">
      <template #form>
        <o-edit-time :only-arrival="true" />
      </template>
      <o-button
        label="Wijziging bevestigen"
        :is-primary="true"
        @click="hideOverlay('tijd')"
      />
    </o-overlay>
    <o-overlay ref="infoOverlay">
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut consectetur
        accumsan libero. Nullam quis elit at metus viverra tempor. Vivamus metus
        magna, dapibus at lacus et, tincidunt cursus tellus.
      </p>
    </o-overlay>
    <o-overlay title="Support" ref="supportOverlay">
      <div class="c-bottom-overlay__list">
        <o-list-item
          icon="link"
          label="Meest gestelde vragen"
          :chevron="false"
        />
      </div>
    </o-overlay>
  </o-view>
</template>

<script>
import OCambioReservationForm from '@/components/OCambioReservationForm.vue'
import OMap from '@/components/OMap.vue'
import OPayButton from '@/components/OPayButton.vue'
import OOverlay from '@/components/base/OOverlay.vue'
import OEditTime from '@/components/overlays/OEditTime.vue'
export default {
  name: 'CambioEdit',
  components: {
    OEditTime,
    OOverlay,
    OCambioReservationForm,
    OMap,
    OPayButton
  },
  data() {
    return {
      showInfoOverlay: false,
      showSupportOverlay: false,
      markers: [
        {
          coordinates: [3.715, 51.05],
          type: 'cambio',
          title: 'Cambio A',
          link: 'poi/cambio'
        },
        {
          coordinates: [3.723, 51.053],
          type: 'cambio',
          title: 'Cambio B',
          link: 'poi/cambio'
        },
        {
          coordinates: [3.72, 51.055],
          type: 'cambio',
          title: 'Cambio C',
          link: 'poi/cambio'
        }
      ]
    }
  },

  methods: {
    cancelReservation() {
      this.$router.push({ name: 'providerscambioreservations' })
    },

    showStandInfo() {
      this.$router.push({ name: 'providerscambiostandinfo' })
    },

    showKlasseInfo() {
      this.$router.push({ name: 'providerscambioclassinfo' })
    }
  }
}
</script>

<style lang="scss"></style>
